import { useEffect, useState } from "react";
import AuthorManager from "../../../services/home/AuthorManager";
import { Loader2 } from "lucide-react";
import config from "../../../config";

const AuthorProfile = ({ authorId }) => {
  const [author, setAuthor] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAuthor = async () => {
      try {
        const response = await AuthorManager.getAuthorById(authorId);
        setAuthor(response.responseData);
      } catch (error) {
        console.error("Failed to fetch author:", error);
      } finally {
        setLoading(false);
      }
    };

    if (authorId) {
      fetchAuthor();
    }
  }, [authorId]);

  if (loading) {
    return (
      <div className="flex justify-center items-center p-6">
        <Loader2 className="animate-spin w-8 h-8 text-primary" />
      </div>
    );
  }

  if (!author) {
    return <div className="text-center text-gray-500 p-6">Author not found.</div>;
  }

  return (
    <div className="flex justify-center py-2">
      <div className="w-full max-w-4xl flex flex-col md:flex-row items-center md:items-start p-6 rounded-2xl shadow-md bg-white gap-6">
        <img
          src={
            author.authorImage
              ? `${config.url}/authorImages/${author.authorImage}`
              : `/images/default_author_img.png`
          }
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = "/images/default_author_img.png";
          }}
          alt={author.authorName}
          className="w-32 h-32 object-cover rounded-full shadow-lg"
        />

        <div className="text-center md:text-left">
          <h2 className="text-2xl font-bold text-primary">{author.authorName}</h2>
          <p className="text-gray-600 max-w-2xl mt-2">{author.aboutAuthor}</p>
        </div>
      </div>
    </div>
  );
};

export default AuthorProfile;
